import { SMS } from "../../service/user";

const state = {
  interval: 60, // 发送短信验证码最小间隔
  sendStatus: true, // 当前短信是否可以发送
  time: null // 发送验证码定时器
};

const mutations = {
  // 修改验证码是否可以发送状态
  SET_SEND_STATUS: (state, bool) => {
    state.sendStatus = bool;
  },
  // 发送验证码剩余时间
  SET_TIME_REMAINING: state => {
    state.interval--;
    if (state.interval === -1) {
      clearInterval(state.time);
      state.sendStatus = true;
      state.time = null;
      state.interval = 60;
    }
  },
  // 手动重置短信发送状态及倒计时
  RESET_SMS: state => {
    clearInterval(state.time);
    state.sendStatus = true;
    state.interval = 60;
    state.sendStatus = true;
  }
};

const actions = {
  // 发送验证码
  sendSMS({ commit, state, rootState }, data) {
    return new Promise((resolve, reject) => {
      if (state.sendStatus) {
        // 未传手机号码则使用当前登录用户手机
        const { bizType, phoneNo = rootState.user.phoneNum } = data;
        // 拦截不符合的手机号
        let reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
        if (reg.test(phoneNo)) {
          commit("SET_SEND_STATUS", false);
          SMS({ bizType, phoneNo })
            .then(res => {
              resolve(res);
              state.time = setInterval(() => {
                commit("SET_TIME_REMAINING");
              }, 1000);
            })
            .catch(err => {
              commit("SET_SEND_STATUS", true);
              reject(err);
            });
        }
      }
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
